import { render, staticRenderFns } from "./paba.vue?vue&type=template&id=30101864&lang=pug"
import script from "./paba.vue?vue&type=script&lang=js"
export * from "./paba.vue?vue&type=script&lang=js"
import style0 from "./paba.vue?vue&type=style&index=0&id=30101864&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports